import { withAuthenticationRequired } from "@auth0/auth0-react";
const { PageLoader } = require("./page-loader");

export const ProtectedRoute = ({ component }: any) => {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => (
      <div className="page-layout">
        <PageLoader />
      </div>
    ),
  });

  return <Component />;
};
